import { FormSetting } from '@/form-settings/form-setting';
import { ControlBase } from '@components/dynamic-form/control-base';
import { ControlType } from '@components/dynamic-form/control-type';
import { DateControl } from '@components/dynamic-form/date-control';
import { DropdownControl } from '@components/dynamic-form/dropdown/dropdown-control';

export class ReturnRentalMovementFormSetting extends FormSetting {
  private static rows: ControlBase[] = [];

  public static getMeta(): Array<any> {
    this.rows = [];

    this.addRowCarburanteConsegna();
    this.addRowDataConsegna();
    this.addRowKmConsegna();
    this.addRowCarburanteRientro();
    this.addRowDataRientro();
    this.addRowKmRientro();
    this.addRowDanniRientro();
    this.addRowPuliziaRientro();
    this.addRowTotaleIncassato();
    this.addRowDurataGiorni();

    return [
      {
        rows: this.rows,
        order: 1,
      },
    ];
  }

  private static addRowCarburanteConsegna() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.key = 'carburanteConsegna';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Carburante Consegna';
    inputsComponent.class = 'w-4/12';
    inputsComponent.disabled = true;
    inputsComponent.options = [
      { key: 'VUOTO', value: 'Vuoto' },
      { key: 'UNO', value: '1/8' },
      { key: 'DUE', value: '2/8' },
      { key: 'TRE', value: '3/8' },
      { key: 'QUATTRO', value: '4/8' },
      { key: 'CINQUE', value: '5/8' },
      { key: 'SEI', value: '6/8' },
      { key: 'SETTE', value: '7/8' },
      { key: 'OTTO', value: '8/8' },
    ];

    this.rows.push(inputsComponent);
  }

  private static addRowDataConsegna() {
    const inputsComponent = {} as DateControl;
    inputsComponent.key = 'dataConsegna';
    inputsComponent.controlType = ControlType.dateTime;
    inputsComponent.label = 'Data e ora consegna';
    inputsComponent.class = 'w-4/12';
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowKmConsegna() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'kmConsegna';
    inputsComponent.controlType = ControlType.number;
    inputsComponent.label = 'KM Consegna';
    inputsComponent.class = 'w-4/12';
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowCarburanteRientro() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.key = 'carburanteRientro';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Carburante Rientro';
    inputsComponent.class = 'w-2/12';
    inputsComponent.required = true;
    inputsComponent.options = [
      { key: 'VUOTO', value: 'Vuoto' },
      { key: 'UNO', value: '1/8' },
      { key: 'DUE', value: '2/8' },
      { key: 'TRE', value: '3/8' },
      { key: 'QUATTRO', value: '4/8' },
      { key: 'CINQUE', value: '5/8' },
      { key: 'SEI', value: '6/8' },
      { key: 'SETTE', value: '7/8' },
      { key: 'OTTO', value: '8/8' },
    ];

    this.rows.push(inputsComponent);
  }

  private static addRowDataRientro() {
    const inputsComponent = {} as DateControl;
    inputsComponent.key = 'dataRientro';
    inputsComponent.controlType = ControlType.dateTime;
    inputsComponent.label = 'Data Rientro';
    inputsComponent.class = 'w-6/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowKmRientro() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'kmRientro';
    inputsComponent.controlType = ControlType.number;
    inputsComponent.label = 'KM Rientro';
    inputsComponent.class = 'w-4/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowDanniRientro() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'danniRientro';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Danni Riconsegna';
    inputsComponent.class = 'w-full';

    this.rows.push(inputsComponent);
  }

  private static addRowPuliziaRientro() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'puliziaVeicoloRientro';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Pulizia veicolo rientro';
    inputsComponent.class = 'w-4/12';
    inputsComponent.options = [
      { key: 'PULITA', value: 'Pulita (Ispezione completa)' },
      { key: 'SPORCA', value: 'Sporca (Impossibile verificare danni su carrozzeria)' },
      { key: 'MOLTO_SPORCA', value: 'Molto Sporca (Addebito pulizia straordinaria Art. 3.A)' },
    ];

    this.rows.push(inputsComponent);
  }

  private static addRowTotaleIncassato() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'totaleIncassato';
    inputsComponent.controlType = ControlType.number;
    inputsComponent.label = 'Totale incassato';
    inputsComponent.class = 'w-4/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowDurataGiorni() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'durataGiorni';
    inputsComponent.controlType = ControlType.number;
    inputsComponent.label = 'Durata giorni';
    inputsComponent.class = 'w-4/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }
}
